import { useThemeStore } from '@/stores/theme';

export const initializeTypes = (): Array<{ name: string; selected: boolean }> => {
  const themeStore = useThemeStore();
  const arr = [{ name: 'Online', selected: false }];

  if (themeStore.current === 'layby') {
    arr.push({ name: 'In-store', selected: false });
  }

  return arr;
};

export const initializeDurations = (): Array<{ name: string; value: number | string; selected: boolean }> => {
  const arr = [];
  for (let i = 3; i <= 12; i++) {
    arr.push({ name: `${i} months`, value: i, selected: false });
  }
  arr.push({ name: '> 12 months', value: '12+', selected: false });
  return arr;
};

export const initializeRewardPercentages = () => [
  { name: '0-10%', selected: false },
  { name: '10-20%', selected: false },
  { name: '20-30%', selected: false },
  { name: '30%+', selected: false },
];

export const initializeMinimumAmounts = () => {
  return [
    { name: '< R1000', selected: false },
    { name: 'R1000', selected: false },
    { name: 'R2000', selected: false },
    { name: 'R3000', selected: false },
    { name: 'R4000', selected: false },
    { name: 'R5000+', selected: false },
  ];
};
